import React, { useMemo, useState } from "react";

function isEmailValid(email) {
  const e = String(email || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // Anti-spam simple (champ caché)
  const [website, setWebsite] = useState("");

  const contactEmail = "contact@pdf-converter.fr"; // <-- remplace par ton email

  const errors = useMemo(() => {
    const errs = {};
    if (!name.trim()) errs.name = "Ton nom est requis.";
    if (!email.trim()) errs.email = "Ton email est requis.";
    else if (!isEmailValid(email)) errs.email = "Email invalide.";
    if (!subject.trim()) errs.subject = "Le sujet est requis.";
    if (!message.trim()) errs.message = "Le message est requis.";
    if (message.trim().length < 10)
      errs.message = "Message trop court (min. 10 caractères).";
    return errs;
  }, [name, email, subject, message]);

  const canSend = Object.keys(errors).length === 0;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Honeypot rempli => bot => on ignore
    if (website.trim()) return;

    if (!canSend) return;

    // ✅ MODE 1 : mailto (local, sans backend)
    const body = [`Nom: ${name}`, `Email: ${email}`, "", message].join("\n");

    const mailto = `mailto:${encodeURIComponent(
      contactEmail
    )}?subject=${encodeURIComponent(
      `[Contact] ${subject}`
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailto;

    // (Option) reset
    // setName(""); setEmail(""); setSubject(""); setMessage("");
  };

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Contact</h1>
      <p style={{ opacity: 0.8, marginTop: 6 }}>
        Une question, une idée d’outil à ajouter, un bug à signaler ? Envoie-moi
        un message.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.2fr 0.8fr",
          gap: 16,
          alignItems: "start",
        }}
      >
        {/* FORM */}
        <form onSubmit={handleSubmit} style={cardStyle}>
          {/* Honeypot (caché) */}
          <div
            style={{
              position: "absolute",
              left: "-5000px",
              top: "auto",
              width: 1,
              height: 1,
              overflow: "hidden",
            }}
          >
            <label>
              Ne pas remplir
              <input
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
            </label>
          </div>

          <h2 style={{ marginTop: 0, fontSize: 18 }}>Formulaire</h2>

          <Field
            label="Nom"
            value={name}
            setValue={setName}
            placeholder="Ton nom"
            error={errors.name}
          />

          <Field
            label="Email"
            value={email}
            setValue={setEmail}
            placeholder="ton@email.com"
            error={errors.email}
          />

          <Field
            label="Sujet"
            value={subject}
            setValue={setSubject}
            placeholder="Ex: Bug sur l’outil de mensualité"
            error={errors.subject}
          />

          <label style={{ display: "block", marginBottom: 12 }}>
            Message
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Décris ton besoin (le plus précisément possible)."
              rows={7}
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 10,
                border: errors.message ? "1px solid #e57373" : "1px solid #ddd",
                resize: "vertical",
              }}
            />
            {errors.message && <div style={errorStyle}>{errors.message}</div>}
          </label>

          <button
            type="submit"
            disabled={!canSend}
            style={{
              ...btnStyle,
              opacity: canSend ? 1 : 0.6,
              cursor: canSend ? "pointer" : "not-allowed",
              fontWeight: 800,
            }}
          >
            Envoyer
          </button>

          <p style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
            En cliquant sur “Envoyer”, ton application mail s’ouvre avec le
            message pré-rempli.
          </p>
        </form>

        {/* INFO */}
        <div style={cardStyle}>
          <h2 style={{ marginTop: 0, fontSize: 18 }}>Contact direct</h2>
          <p style={{ marginTop: 6, opacity: 0.8 }}>
            Tu peux aussi envoyer un mail directement :
          </p>
          <div style={{ fontWeight: 800 }}>{contactEmail}</div>

          <div
            style={{
              marginTop: 14,
              paddingTop: 14,
              borderTop: "1px solid #eee",
            }}
          >
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Conseil</div>
            <div style={{ fontSize: 13, opacity: 0.75 }}>
              Si c’est un bug, précise : l’outil concerné, ce que tu as fait, et
              ce que tu attends.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, setValue, placeholder, error }) {
  return (
    <label style={{ display: "block", marginBottom: 12 }}>
      {label}
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: 10,
          marginTop: 6,
          borderRadius: 10,
          border: error ? "1px solid #e57373" : "1px solid #ddd",
        }}
      />
      {error && <div style={errorStyle}>{error}</div>}
    </label>
  );
}

const cardStyle = {
  border: "1px solid #e6e6e6",
  borderRadius: 14,
  padding: 14,

  position: "relative",
};

const btnStyle = {
  padding: "10px 14px",
  borderRadius: 12,
  border: "1px solid #ddd",
  background: "white",
};

const errorStyle = {
  marginTop: 6,
  fontSize: 12,
  color: "#c62828",
};
